import PropTypes from "prop-types";
import Link from "next/link";
import styles from "./styles/quote.module.css";

export function Quote({ editorial }) {
  if (!editorial) {
    return null;
  }
  if (!editorial.card) {
    return null;
  }
  const { quote, author, cta } = editorial.card;
  return (
    <Link href={`/editorials/${editorial.slug.current}`}>
      <a className={styles.container}>
        <blockquote className={styles.quote}>“{quote}”</blockquote>
        <p className={styles.author}>{author}</p>
        <p className={styles.cta}>{cta}</p>
      </a>
    </Link>
  );
}

Quote.propTypes = {};
